import { P0, S, abs, fillAt, rotPts } from '../../geometry';

export const hanger = {
  name: 'Hanger',
  colors: ['#161616', '#E5484D'],
  draw(m, t) {
    let swing = 5 * S(t * 1.3),
      lift = 0,
      curlK = 1,
      pose = P0();
    if (m === 'happy') {
      swing = 14 * S(t * 6);
      lift = -2 * abs(S(t * 6));
    }
    // Thinking: swings like a pendulum, never quite stopping.
    if (m === 'thinking') swing = 18 * S(t * 2.2);
    if (m === 'talking') {
      swing = 4 * S(t * 2);
      lift = 1.5 * S(t * 10);
    }
    if (m === 'surprised') {
      curlK = 1.6;
      swing = 1.5 * S(t * 24);
      lift = -3;
    }
    if (m === 'paused') swing = 10 + S(t * 0.7);
    const pivot = [50, 12 + lift];
    const hook = [
      [50, 30],
      [50, 23],
      [50 + 6 * curlK, 13],
      [50 + 12 * curlK, 16],
      [50 + 10 * curlK, 23],
    ];
    const frame = [
      [50, 30],
      [32, 45],
      [13, 63],
      [50, 66],
      [87, 63],
      [68, 45],
      [50, 30],
    ];
    const parts = [hook, frame].map((p) =>
      rotPts(
        p.map(([x, y]) => [x, y + lift]),
        pivot[0],
        pivot[1],
        swing
      )
    );
    const eye = rotPts([[50, 53 + lift]], pivot[0], pivot[1], swing)[0];
    return {
      strokes: [
        { c: 'b', pts: parts[0] },
        { c: 'a', pts: parts[1] },
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1),
};
